import { FormBankStatements } from './components/FormBankStatements';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { submitBankStatements, validateBsoReceived } from '../../reducers/customer-slice';
import { useQuery } from '../../util/hooks';
import { AppThunkDispatch } from '../../util/store';
import { useAppStepNavigation } from '../../util/hooks/useAppStepNavigation';
import { ModalVerifyBankStatements } from './components/ModalVerifyBankStatements';
import { useModal } from '@payright/web-components';

export const BankStatementsOnlineBankingContent = () => {
  const { openModal } = useModal();

  const query = useQuery();
  const queryParamCheckoutId = query.get('checkoutId')!;

  const { goToStep } = useAppStepNavigation();

  const dispatch = useDispatch<AppThunkDispatch>();

  const globalAuthState = useSelector((state: RootState) => state.auth);
  const globalCheckoutState = useSelector((state: RootState) => state.checkout);
  const globalCustomerState = useSelector((state: RootState) => state.customer);

  const customerId = globalAuthState.customerId || '';
  const customerNumber = globalCustomerState.customerNumber || '';
  const loading = globalCheckoutState.loading || globalCustomerState.loading;

  const handleSubmit = () => {
    openModal(
      <ModalVerifyBankStatements
        onComplete={handleComplete}
        validateBsoReceived={validateBsoReceived}
      />
    );
  };

  const handleComplete = async () => {
    const nextStep = await dispatch(submitBankStatements(queryParamCheckoutId, customerId, {}));

    goToStep(nextStep);
  };

  return (
    <FormBankStatements
      customerNumber={customerNumber}
      loading={loading}
      onSubmit={handleSubmit}
      onCancel={() => {}}
    />
  );
};
